// Matchup Preview (S2) — revived from the killed "Playoff Outlook" feature as a rolling
// next-4-weeks schedule-difficulty read, shown every week in-season instead of a Weeks-14-17-only
// playoff view. Extracted into its own module (rather than a local const in LeagueView.jsx) so
// tests can jest.mock() it to exercise both code paths without a real feature flag flip.
export const MATCHUP_PREVIEW_ENABLED = true;
